import { createFileRoute } from '@tanstack/react-router'
import GoalsSettings from '~/routes/_authenticated/$alias/settings/scorecards/-components/goals'

export const Route = createFileRoute('/_authenticated/$alias/settings/goals')({
  component: GoalsSettings,
})
